import React from 'react';
import {Link} from 'gatsby'

const AgendaBreadcrumb = ({SingleTitle}) => (
	<div className="d-none d-lg-block d-md-block d-sm-block order-bottom py-2">
		<div className="container">
			<nav className="" aria-label="breadcrumb">
				<ol className="breadcrumb">
					<li className="breadcrumb-item"><Link className="text-dark" to="/">Accueil</Link></li>
					<li className="breadcrumb-item"><Link className="text-dark" to="/sortir-a-roubaix/">Sortir à Roubaix</Link></li> 
					{ SingleTitle ?  <li className="text-secondary breadcrumb-item"><Link className="text-dark" to="/agenda/">Agenda</Link></li> : <li className="text-secondary breadcrumb-item">Agenda</li> }
					{ SingleTitle ? <li className="text-secondary breadcrumb-item">{SingleTitle}</li> : '' }
				</ol>
			</nav>
		</div>
	</div>
)

export default AgendaBreadcrumb;